import React, { Component } from 'react'

import './OnlineText.css'

class OnlineText extends Component {
  render() {
    return (
      <div className="OnlineText-container">
        <h1>You must go offline to use this editor.</h1>
        <p>Disconnect to continue</p>
      </div>
    )
  }
}

export default OnlineText



// WEBPACK FOOTER //
// ./src/OnlineText.js